<h2 mat-dialog-title>{{'dialog.password-change.title' | translate}}</h2>

<pm-password-change mat-dialog-content #passwordChange (submitted)="onSubmit($event)" [username]="data.username" [presetCurrentPassword]="presetCurrentPassword"></pm-password-change>
<div mat-dialog-actions>
  <button mat-button color="primary" (click)="passwordChange.submit()" [disabled]="!passwordChange.valid">{{'dialog.password-change.change-password' | translate}}
  </button>
  @if (!data.passwordChangeRequired) {
    <button mat-button mat-dialog-close>{{'button.cancel' | translate}}
    </button>
  }
</div>
